import {
  mdiPlus,
  mdiArrowTopRight,
  mdiHistory,
  mdiArrowBottomLeft,
  mdiFilterVariant,
  mdiPaperclip,
} from "@mdi/js";
import Icon from "@mdi/react";
import { debounce, round } from "lodash";
import moment from "moment";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import LoadingWidget from "../../../context_providers/modal/loader";
import {
  ModalType,
  ModalAlignment,
} from "../../../context_providers/modal/modal_context";
import {
  useToast,
  ToastType,
} from "../../../context_providers/toast/toast_ctx";
import {
  fetchDelete,
  fetchGet,
  fetchPost,
  toQueryString,
} from "../../../service/api_client";
import SearchFieldWidget from "../../../ui/new_components/search_field";
import { UTCToLocalDate } from "../../../utils/date_util";
import { urls } from "../../../utils/urls";
import {
  AttachmentModel,
  PurchaseOrderModelV2,
  PurchaseOrderStatus,
  getFileType,
  po_approval_status,
} from "../model/purchase_order_model";
import { ACTION, file_dir, MODULE } from "../../../utils/enums";
import axios from "axios";
import DrawerWidget from "../../../context_providers/modal/drawer_widget";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../ui/new_components/common/drawer_modal";
import ActionHistory from "../purchase_order_create/components/transfer_logs";
import ModalDialog from "../../../ui/new_components/common/modal";
import { POListFilter } from "../purchase_order_create/models/enums";
import { getPurchaseOrderListDataRepo } from "../purchase_order_create/service/po_service";
import AttachmentSectionV2 from "../purchase_order_create/components/attachment_widget_v2";
import Pagination from "../../../ui/new_components/common/pagination";
import {
  CostCenterMultiFilter,
  ItemMultiFilter,
  OptionsMultiFilter,
  PoCreatorMultiFilter,
  ProjectMultiFilter,
  VendorMultiFilter,
} from "../../../ui/new_components/entity_selects/EntityMultiFilters";
import ExportPO from "../purchase_order_create/components/PONewExportWidget";
import { formatAmountWithCommas } from "../../../ui/pages/content_panel/utils/helpers";
import { currencyFormat } from "../../../utils/currency_format";
import FileDropZone from "../../../ui/new_components/common/file_drop_zone";
import { parse } from "papaparse";
import { useAuth } from "../../../context_providers/auth/authProvider";
import { sendToTyno } from "../../purchase_order_report/service/po_report_repo";
import {
  ResponsiveListShell,
  FilterSheet,
  DateRangeFilter,
  MobileRecordCard,
  MobileRecordCardList,
  StatusBadge,
  EmptyState,
} from "../../../ui/new_components/common/responsive";

const defaultFilter = (): POListFilter => {
  return {
    page: 1,
    count: 50,
    all: false,
  };
};
interface PurchaseOrderListScreenProps {
  location?: any;
}

const PurchaseOrderListScreen: FunctionComponent<
  PurchaseOrderListScreenProps
> = (props) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order`;

  const [showExport, setShowExport] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [ShowHistory, setShowHistory] = useState<any>();
  const [ShowHistory1, setShowHistory1] = useState<any>();
  const tempFilter = localStorage.getItem("po_list_filter");
  const [selectedPO, setSelectedPO] = useState<PurchaseOrderModelV2 | null>();
  const [filter, setFilter] = useState<POListFilter>(
    tempFilter
      ? { ...JSON.parse(tempFilter), project_name: undefined }
      : defaultFilter,
  );
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState<PurchaseOrderModelV2[]>([]);
  const navigation = useHistory();
  const [showAttachment, setShowAttachment] = useState<PurchaseOrderModelV2>();
  const [attachmentKey, setAttachmentKey] = useState(Math.random() * 10000);
  const [bulkPO, setBulkPO] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessages, setErrorMessages] = useState<string | null>(null);
  const [showPOModal, setShowPOModal] = useState(false);
  const [poCreated, setPoCreated] = useState<string | null>(null);
  const { isAuthorised } = useAuth();
  const [procuremntRead, setProcurementRead] = useState(false);
  const [showFilter, setShowFilter] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= 768,
  );

  const getInwardStatus = (item: PurchaseOrderModelV2) =>
    item.total_received_qty === 0
      ? "Pending"
      : (item.total_po_qty ?? 0) > (item.total_received_qty ?? 0)
        ? "Partial"
        : "Completed";

  const handleSelection = (selectedItem: PurchaseOrderModelV2) => {
    if (selectedItem.status === "Saved Draft") {
      return `${urls.purchase_order}/create/${selectedItem.id}`;
    }
    return `${urls.purchase_order}/view-detail/${selectedItem.id}`;
  };

  useEffect(() => {
    const procuremnt_read_only = isAuthorised({
      module: MODULE.procurement_read_only,
      action: ACTION.READ,
    });
    const bulk_po_permission = isAuthorised({
      module: MODULE.po_bulk_import,
      action: ACTION.CREATE,
    });

    setProcurementRead(procuremnt_read_only);
    setBulkPO(bulk_po_permission);
  }, [isAuthorised]);

  const onImport = async (file: File) => {
    setLoading(true);

    try {
      const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/bulk-po-upload`;
      const form = new FormData();
      form.append("file", file, file.name);

      let result;

      try {
        result = await fetchPost(url, form);
        if (result.success) {
          if (result?.created_po_list?.length > 0) {
            setPoCreated(result.created_po_list.join("\n"));
            setShowPOModal(true);
          }
        }
        if (result.response?.data) {
          result = result.response.data;
          // Extract and display non-existent items if present
          if (result.non_existent_items?.length > 0) {
            const errorMessages = Object.entries(result.non_existent_items)
              .map(([key, value]) =>
                typeof value === "object"
                  ? `${key}: ${JSON.stringify(value)}`
                  : `${key}: ${value}`,
              )
              .join("\n");
            setErrorMessages(errorMessages);
            setShowErrorModal(true);
          }
        }
      } catch (error: any) {
        throw error;
      }

      if (result?.success) {
        showToast({
          type: ToastType.success,
          text: result.message || "Upload succeeded",
        });
      } else {
        showToast({
          type: ToastType.error,
          text: result.error || "An unexpected error occurred.",
        });
      }
    } catch (err: any) {
      showToast({
        type: ToastType.error,
        text: err.message || "Upload failed.",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async (prop: POListFilter) => {
    setLoading(true);
    try {
      const res = await getPurchaseOrderListDataRepo(prop);
      if (res.success) {
        setData(res.data.data);
        if (res.data.metadata) {
          setTotal(res.data.metadata.total);
        }
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedHandler = useCallback(
    debounce((prop: POListFilter) => {
      if (prop) fetchData(prop);
      else setData([]);
    }, 100),
    [],
  );

  const handleDownloadTemplate = () => {
    const headers = requiredHeaders;

    const csvContent = [headers]
      .map((row) => row.map((cell) => `"${cell}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "bulk_po_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    localStorage.setItem("po_list_filter", JSON.stringify(filter));
    debouncedHandler(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const uploadFile = async ({
    file,
    category,
    removeSelectedFile,
    setShowUpload,
  }: {
    file: File;
    category: string;
    removeSelectedFile: () => void;
    setShowUpload: (v: boolean) => void;
  }) => {
    try {
      if (!file || !category) {
        showToast({
          type: ToastType.warning,
          text: "Please select file and category",
        });
        return;
      }
      setLoading(true);
      const { name, type } = file;
      const create_url = `${url}/${showAttachment?.id}/attachment`;
      const get_signed_urls = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/signed-url`;
      const query = {
        mimetype: type,
        extension: name.split(".").pop(),
        dir: file_dir.pocuremnt_attachments,
      };
      const res = await fetchGet(get_signed_urls + toQueryString(query));
      if (res.success) {
        const { signed_url, url } = res.data;

        const aws_res = await axios.put(signed_url, file, {
          headers: {
            "Content-Type": type,
          },
        });

        const attachment: AttachmentModel = {
          id: "",
          category,
          type: getFileType(type),
          url,
        };
        const create_res = await fetchPost(create_url, attachment);
        if (create_res.success) {
          const uploadedAttachment = create_res.data; // backend already returns data

          showToast({
            type: ToastType.success,
            text: create_res.message,
          });

          setData((o) => [
            ...o.map((f) => {
              if (f.id === showAttachment)
                return {
                  ...f,
                  attachments: [...(f.attachments || []), uploadedAttachment],
                };
              return f;
            }),
          ]);

          if (
            uploadedAttachment?.category &&
            uploadedAttachment.category.toLowerCase().trim() === "tax invoice"
          ) {
            try {
              if (showAttachment?.approval_status !== "Approved") {
                showToast({
                  type: ToastType.info,
                  text: "Attachment uploaded successfully, but unapproved PO attachments cannot be sent to Tyno.",
                });
              } else {
                const tynoRes = await sendToTyno(
                  showAttachment?.po_no || "",
                  showAttachment?.id || "",
                  uploadedAttachment,
                );

                if (tynoRes.success) {
                  showToast({
                    type: ToastType.success,
                    text: "Sent to Tyno",
                  });
                } else {
                  showToast({
                    type: ToastType.error,
                    text: "Upload succeeded but sending to Tyno failed",
                  });
                }
              }
            } catch (err: any) {
              showToast({
                type: ToastType.error,
                text: "Error sending to Tyno: " + err.message,
              });
            }
          }

          removeSelectedFile();
          setShowUpload(false);
          setAttachmentKey(Math.random() * 1000);
        }
      }
      setLoading(false);
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text: error.message,
      });
      setLoading(false);
    }
  };
  const deleteFile = async (att: AttachmentModel) => {
    try {
      if (!window.confirm("Are your sure to delete ?")) return;
      if (!att) {
        showToast({
          type: ToastType.warning,
          text: "Please select file",
        });
        return;
      }
      setLoading(true);
      const attachmentUrl = `${url}/${showAttachment?.id}/attachment/${att.id}`;

      const res = await fetchDelete(attachmentUrl);

      if (res.success) {
        showToast({
          type: ToastType.success,
          text: res.message,
        });
        setData((o) => [
          ...o.map((f) => {
            if (f.id === showAttachment) {
              f.attachments = f.attachments.filter((f) => f.id !== att.id);
            }
            return f;
          }),
        ]);

        setAttachmentKey(Math.random() * 1000);
      }
      setLoading(false);
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text: error.message,
      });
      setLoading(false);
    }
  };

  const onSelectAttchment = (d: AttachmentModel) => {
    window.open(d.url, "_blank");
  };

  const clearLocalStore = () => {
    // Remove from localStorage
    localStorage.removeItem("po_list_filter");

    // Reset filter state
    const defaultFilterObj = defaultFilter();
    setFilter(defaultFilterObj);

    // Trigger UI updates and fetch
    debouncedHandler(defaultFilterObj);
    fetchData(defaultFilterObj);
  };

  const requiredHeaders = [
    "PO Serial No.",
    "Vendor Code",
    "Bill To GST No.",
    "Warehouse Id",
    "Item Code",
    "Project ID",
    "Qty",
    "Price",
    "Delivery Date",
    "Delivery terms",
    "Payment terms",
  ];

  return (
    <>
      {showImport && (
        <ModalDialog
          id="po_list_import_modal"
          show={showImport}
          onClose={() => setShowImport(false)}
          title="Import POs "
        >
          <div className="text-xs w-96">
            <h2 className="font-semibold">Please note :</h2>
            <p>sheet should have header as</p>
            <p className="font-semibold text-purple-500">
              [{requiredHeaders.join(", ")}]
            </p>
            <p>In the first row of csv.</p>
          </div>
          <div className="h-96 w-96 mt-5">
            <FileDropZone
              accept=".csv"
              onDrop={(files) => {
                parse<any>(files[0], {
                  header: true,
                  skipEmptyLines: true,
                  complete: ({ data: rows, errors, meta }) => {
                    if (rows.length === 0) {
                      showToast({
                        type: ToastType.info,
                        text: "No record found !",
                      });
                      return;
                    }

                    const keys = meta.fields || Object.keys(rows[0]);
                    const missing = requiredHeaders.filter(
                      (h) => !keys?.includes(h),
                    );
                    if (missing.length) {
                      showToast({
                        type: ToastType.error,
                        text: `Required headers missing: [${missing.join(
                          ", ",
                        )}]`,
                      });
                      return;
                    }

                    setShowImport(false);
                    onImport(files[0]);
                  },
                });
              }}
            />
          </div>
        </ModalDialog>
      )}

      {showExport && (
        <ModalDialog
          id="po_list_export_modal"
          show={showExport}
          title="Export"
          onClose={() => setShowExport(false)}
        >
          <ExportPO filter={filter} />
        </ModalDialog>
      )}
      {ShowHistory && (
        <DrawerModal
          id="po_list_history_drawer"
          location={DrawerModalLoaction.right}
          show={ShowHistory !== undefined}
          onClose={() => setShowHistory(undefined)}
          title="History"
        >
          <ActionHistory po_no={ShowHistory} data={ShowHistory1} />
        </DrawerModal>
      )}
      {showAttachment && (
        <DrawerWidget
          id="po_list_attachments_drawer"
          data={{
            id: 1,
            title: "Attchments",
            type: ModalType.drawer,
            alignment: ModalAlignment.right,
            container: (
              <AttachmentSectionV2
                key={attachmentKey}
                poNo={showAttachment}
                attachments={showAttachment.attachments}
                onSubmit={uploadFile}
                onDelete={deleteFile}
                onSelect={onSelectAttchment}
              />
            ),
          }}
          onClose={function (): void {
            setShowAttachment(undefined);
          }}
        ></DrawerWidget>
      )}
      {showErrorModal && (
        <ModalDialog
          id="po_list_import_errors_modal"
          show={showErrorModal}
          title="Import Errors"
          onClose={() => setShowErrorModal(false)}
        >
          <div className="p-4">
            <pre className="bg-gray-100 p-2 rounded text-red-600 whitespace-pre-wrap">
              {errorMessages}
            </pre>
          </div>
        </ModalDialog>
      )}
      {showPOModal && (
        <ModalDialog
          id="po_list_bulk_created_modal"
          show={showPOModal}
          title="Created PO's after Bulk Upload"
          onClose={() => setShowPOModal(false)}
        >
          <div className="p-4">
            <pre className="bg-gray-100 p-2 rounded text-blue-600 whitespace-pre-wrap max-h-64 overflow-y-auto">
              {poCreated}
            </pre>
          </div>
        </ModalDialog>
      )}

      <ResponsiveListShell
        title="Purchase Orders"
        count={total}
        onRefresh={() => fetchData(filter)}
        search={
          <div id="po_list_search">
            <SearchFieldWidget
              placeholder="Search PO ID"
              defaulValue={filter.po_no ?? ""}
              onClear={() => setFilter((p) => ({ ...p, po_no: "" }))}
              onSubmit={(value) => setFilter((p) => ({ ...p, po_no: value }))}
            />
          </div>
        }
        actions={
          <>
            <button
              id="po_list_clear_filter_btn"
              className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-xs text-white transform"
              onClick={() => clearLocalStore()}
            >
              Clear Filter
            </button>

            <>
              <button
                id="po_list_export_btn"
                onClick={() => setShowExport(true)}
                className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
              >
                <Icon path={mdiArrowTopRight} className="h-4 w-4"></Icon>
                Export PO
              </button>
              {bulkPO && (
                <div
                  id="po_list_import_btn"
                  onClick={() => setShowImport(true)}
                  className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
                >
                  <Icon path={mdiArrowBottomLeft} size={0.8} />
                  Import
                </div>
              )}
              <label
                id="po_list_download_template_btn"
                title="Download template"
                onClick={handleDownloadTemplate}
                className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
              >
                <Icon path={mdiPaperclip} className="h-4 w-4"></Icon>
                Download Template
              </label>
              {!procuremntRead && (
                <button
                  id="po_list_reorder_btn"
                  onClick={() => {
                    if (selectedPO && selectedPO.po_no) {
                      navigation.push(
                        `${urls.purchase_order}/reorder/${selectedPO.po_no}`,
                      );
                    } else {
                      showToast({
                        type: ToastType.error,
                        text: "Please Select a PO to Re-Order",
                      });
                    }
                  }}
                  className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
                >
                  <Icon path={mdiPlus} className="h-4 w-4"></Icon>Reorder PO
                </button>
              )}
              {!procuremntRead && (
                <button
                  id="po_list_add_po_btn"
                  onClick={() =>
                    navigation.push(urls.purchase_order + "/create")
                  }
                  className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
                >
                  <Icon path={mdiPlus} className="h-4 w-4"></Icon>Add PO
                </button>
              )}
            </>
          </>
        }
        filterToggle={
          <div className="flex gap-2 items-center">
            <h6 className="font-normal text-xs">Filters</h6>
            <div
              id="po_list_filter_toggle_btn"
              onClick={() => setShowFilter((v) => !v)}
              className="flex items-center justify-center bg-gray-200 p-1 rounded-full hover:bg-gray-800 hover:text-white cursor-pointer"
            >
              <Icon path={mdiFilterVariant} className="w-4 h-4" />
            </div>
          </div>
        }
      >
        <FilterSheet
          show={showFilter}
          onClose={() => setShowFilter(false)}
          onApply={() => setShowFilter(false)}
          onReset={() => setFilter(defaultFilter())}
          gridClassName="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-2 items-start"
        >
          <div id="po_list_order_date_filter">
            <label>Order Date</label>
            <DateRangeFilter
              compact
              showChips={false}
              fromDate={
                filter.fromDate
                  ? moment(filter.fromDate).format("YYYY-MM-DD")
                  : undefined
              }
              toDate={
                filter.toDate
                  ? moment(filter.toDate).format("YYYY-MM-DD")
                  : undefined
              }
              onFromChange={(v) => {
                if (!v) {
                  setFilter((o) => ({ ...o, fromDate: undefined }));
                  return;
                }
                const now = UTCToLocalDate(v)!;
                const fromDate = new Date(new Date(now).setHours(0, 0, 0, 0));
                setFilter((o) => ({ ...o, fromDate }));
              }}
              onToChange={(v) => {
                if (!v) {
                  setFilter((o) => ({ ...o, toDate: undefined }));
                  return;
                }
                const now = UTCToLocalDate(v)!;
                const toDate = new Date(
                  new Date(now).setHours(23, 59, 59, 999),
                );
                setFilter((o) => ({ ...o, toDate }));
              }}
            />
          </div>
          <div id="po_list_vendor_filter">
            <label>Vendor</label>
            <VendorMultiFilter
              values={filter.vendor_id}
              onChange={(vendor_id) =>
                setFilter((o) => ({ ...o, page: 1, vendor_id }))
              }
            />
          </div>
          <div id="po_list_created_by_filter">
            <label>Created By</label>
            <PoCreatorMultiFilter
              values={filter.created_by}
              onChange={(created_by) =>
                setFilter((o) => ({ ...o, page: 1, created_by }))
              }
            />
          </div>
          <div id="po_list_cost_center_filter">
            <label>Cost Center</label>
            <CostCenterMultiFilter
              values={filter.cost_center_id}
              onChange={(cost_center_id) =>
                setFilter((o) => ({ ...o, page: 1, cost_center_id }))
              }
            />
          </div>
          <div id="po_list_project_filter">
            <label>Project</label>
            <ProjectMultiFilter
              values={filter.project_id}
              onChange={(project_id) =>
                setFilter((o) => ({ ...o, page: 1, project_id }))
              }
            />
          </div>
          <div id="po_list_item_filter">
            <label>Item</label>
            <ItemMultiFilter
              values={filter.item_code}
              onChange={(item_code) =>
                setFilter((o) => ({ ...o, page: 1, item_code }))
              }
            />
          </div>
          <div id="po_list_po_status_filter">
            <label>PO Status</label>
            <OptionsMultiFilter
              placeholder="Select PO status"
              options={Object.values(PurchaseOrderStatus)}
              values={filter.po_status}
              onChange={(po_status) =>
                setFilter((o) => ({ ...o, page: 1, po_status }))
              }
            />
          </div>
          <div id="po_list_approval_status_filter">
            <label>Approval Status</label>
            <OptionsMultiFilter
              placeholder="Select approval status"
              options={Object.values(po_approval_status)}
              values={filter.approval_status}
              onChange={(approval_status) =>
                setFilter((o) => ({ ...o, page: 1, approval_status }))
              }
            />
          </div>
          <div id="po_list_last_approved_filter">
            <label>Last Approved</label>
            <DateRangeFilter
              compact
              showChips={false}
              fromLabel="Last Approved From"
              toLabel="Last Approved To"
              fromDate={
                filter.last_approved_date
                  ? moment(filter.last_approved_date).format("YYYY-MM-DD")
                  : undefined
              }
              toDate={
                filter.to_last_approved_date
                  ? moment(filter.to_last_approved_date).format("YYYY-MM-DD")
                  : undefined
              }
              onFromChange={(v) =>
                setFilter({
                  ...filter,
                  last_approved_date: v
                    ? new Date(new Date(v).setHours(0, 0, 0, 0))
                    : undefined,
                })
              }
              onToChange={(v) =>
                setFilter({
                  ...filter,
                  to_last_approved_date: v
                    ? new Date(new Date(v).setHours(0, 0, 0, 0))
                    : undefined,
                })
              }
            />
          </div>
          <div id="po_list_inward_status_filter">
            <label>Inward Status</label>
            <OptionsMultiFilter
              placeholder="Select inward status"
              options={["Pending", "Partial", "Completed"]}
              values={filter.po_fulfillment_status}
              onChange={(po_fulfillment_status) =>
                setFilter((o) => ({ ...o, page: 1, po_fulfillment_status }))
              }
            />
          </div>
        </FilterSheet>

        {data.length > 0 ? (
          <>
            <div className="hidden md:block my-2 border">
              <div className="overflow-auto">
                <table
                  id="po_list_table"
                  className="w-full text-xs divide-y divide-gray-200 relative"
                >
                  <thead className="text-xs py-2 bg-white z-10">
                    <tr className="border">
                      <th>
                        <div>
                          <input
                            type="checkbox"
                            checked={selectedPO !== null}
                            disabled
                          />
                        </div>
                      </th>
                      <th className="px-2 py-2">Actions</th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Po No
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        PO Status
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Created At
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Created By Name
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Vendor Name
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Bill to
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Ship to
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Cost Center ID
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Cost Center Name
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Project Name
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        Currency
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        CGST
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        SGST
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        IGST
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        Total Amount(USD)
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        Total Amount(INR)
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        Paid
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        Balance
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Approval Status
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        First Approved By
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Last Approved By
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Last Approved At
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Total Quantity
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Total Inwarded Quantity
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Inward Status
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Attachments
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, i) => (
                      <tr
                        id={`po_list_row_${item.po_no}`}
                        className="border text-center"
                        key={i}
                      >
                        <td>
                          <div className="p-2">
                            <input
                              id={`po_list_row_${item.po_no}_select_checkbox`}
                              type="checkbox"
                              name="selectedItem"
                              checked={selectedPO?.po_no === item.po_no}
                              onChange={() => {
                                setSelectedPO((prev) =>
                                  prev?.po_no === item.po_no ? null : item,
                                );
                              }}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="flex gap-2 justify-center">
                            <div
                              id={`po_list_row_${item.po_no}_history_btn`}
                              className="cursor-pointer"
                              onClick={() => setShowHistory(item.po_no)}
                            >
                              <Icon path={mdiHistory} size="16" />
                            </div>
                          </div>
                        </td>
                        <td
                          id={`po_list_row_${item.po_no}_link`}
                          className="px-3 py-3 whitespace-nowrap text-left cursor-pointer text-blue-600 hover:underline"
                          role="button"
                          onClick={() => {
                            const url = handleSelection(item);
                            navigation.push(url);
                          }}
                        >
                          {item.po_no}
                          {item.version ? `-${item.version}` : ""}
                        </td>
                        {/* Status */}
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          <StatusBadge status={item.status} kind="generic" />
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {moment(item.created_at).format("DD-MM-YYYY") ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {item.created_by_name ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {item.party?.name ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {item.bill_to?.gst_number ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {item.warehouse.name ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {item.items[0]?.project?.cost_center_id ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {item.items[0]?.project?.cost_center_category ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {item.items[0]?.project?.name ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {item.vendor_currency.short_name ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-right">
                          {formatAmountWithCommas(round(item.cgst, 2)) ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-right">
                          {formatAmountWithCommas(round(item.sgst, 2)) ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-right">
                          {formatAmountWithCommas(round(item.igst, 2)) ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-right">
                          {item.vendor_currency.short_name === "USD"
                            ? `${item.vendor_currency.symbol}${currencyFormat(
                                formatAmountWithCommas(round(item.total, 2)),
                              )} `
                            : `--`}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-right">
                          {item.vendor_currency.short_name === "USD"
                            ? (formatAmountWithCommas(
                                round(item.total, 2) *
                                  item.vendor_currency_to_inr,
                              ) ?? "--")
                            : (formatAmountWithCommas(round(item.total, 2)) ??
                              "--")}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-right">
                          {formatAmountWithCommas(item.paid)}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-right">
                          {item.vendor_currency.short_name === "USD" &&
                          item.total > 0
                            ? formatAmountWithCommas(
                                round(
                                  item.total * item.vendor_currency_to_inr -
                                    item.paid,
                                  2,
                                ),
                              )
                            : formatAmountWithCommas(
                                round(item.total - item.paid, 2),
                              )}
                        </td>
                        {/* Approval Status */}
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          <StatusBadge
                            status={item.approval_status}
                            kind="generic"
                          />
                        </td>
                        {/* First Approval By Status */}
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {item.approvals?.[0]?.approved_by_name ?? "--"}
                        </td>
                        {/* Last Approval By Status */}
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {item.approvals?.[item.approvals.length - 1]
                            ?.approved_by_name ?? "--"}
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {(item.approvals ?? []).length > 0
                            ? moment(item?.approvals?.[0]?.approved_at).format(
                                "DD-MM-YYYY",
                              )
                            : item.approval_status === "Approved"
                              ? item.updated_at
                                ? moment(item.updated_at).format("DD-MM-YYYY")
                                : item.created_at
                                  ? moment(item.created_at).format("DD-MM-YYYY")
                                  : "--"
                              : "--"}
                        </td>
                        {/* Total Quantity */}
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {item?.total_po_qty ?? "--"}
                        </td>
                        {/* Total Inwarded Quantity */}
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {item?.total_received_qty ?? "--"}
                        </td>
                        {/* Inward Status */}
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          <StatusBadge
                            status={getInwardStatus(item)}
                            kind="generic"
                          />
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap text-left">
                          {" "}
                          <button
                            id={`po_list_row_${item.po_no}_attachments_btn`}
                            onClick={() => setShowAttachment(item)}
                            className="relative text-sm font-semibold text-blue-400 hover:text-blue-500 whitespace-nowrap sticky-field flex items-center gap-1 px-2 h-full w-full"
                          >
                            View
                            <div>({item?.attachments?.length})</div>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <MobileRecordCardList>
              {data.map((item, i) => (
                <MobileRecordCard
                  id={`po_list_row_mobile_${item.po_no}`}
                  key={i}
                  onClick={() => navigation.push(handleSelection(item))}
                  title={`${item.po_no}${
                    item.version ? `-${item.version}` : ""
                  }`}
                  status={<StatusBadge status={item.status} kind="generic" />}
                  subStatus={
                    <StatusBadge status={item.approval_status} kind="generic" />
                  }
                  fields={[
                    { label: "Vendor", value: item.party?.name ?? "-" },
                    {
                      label: "Created At",
                      value: moment(item.created_at).format("DD-MM-YYYY"),
                    },
                    {
                      label: "Created By",
                      value: item.created_by_name ?? "-",
                    },
                    {
                      label: "Cost Center",
                      value:
                        item.items[0]?.project?.cost_center_category ?? "-",
                    },
                    {
                      label: "Project",
                      value: item.items[0]?.project?.name ?? "-",
                    },
                    {
                      label: "Total (INR)",
                      value:
                        item.vendor_currency.short_name === "USD"
                          ? formatAmountWithCommas(
                              round(item.total, 2) *
                                item.vendor_currency_to_inr,
                            )
                          : formatAmountWithCommas(round(item.total, 2)),
                    },
                    {
                      label: "Balance",
                      value:
                        item.vendor_currency.short_name === "USD" &&
                        item.total > 0
                          ? formatAmountWithCommas(
                              round(
                                item.total * item.vendor_currency_to_inr -
                                  item.paid,
                                2,
                              ),
                            )
                          : formatAmountWithCommas(
                              round(item.total - item.paid, 2),
                            ),
                    },
                    {
                      label: "Inward",
                      value: (
                        <StatusBadge
                          status={getInwardStatus(item)}
                          kind="generic"
                        />
                      ),
                    },
                  ]}
                  actions={[
                    {
                      icon: mdiHistory,
                      title: "History",
                      onClick: () => setShowHistory(item.po_no),
                    },
                    {
                      icon: mdiPaperclip,
                      title: "Attachments",
                      onClick: () => setShowAttachment(item),
                    },
                  ]}
                />
              ))}
            </MobileRecordCardList>

            <div
              id="po_list_pagination"
              className="mt-3 sticky bottom-0 bg-white z-10 border-t flex justify-between items-center px-4 py-2"
            >
              <Pagination
                itemCount={filter.count}
                page={filter.page}
                total={total}
                count={filter.count}
                onChange={(page) => setFilter((o) => ({ ...o, page }))}
              />
            </div>
          </>
        ) : !loading ? (
          <EmptyState
            title="No Purchase Orders found!"
            message="Try adjusting your search or filters."
            imageSrc="/images/nodata.png"
          />
        ) : null}
      </ResponsiveListShell>
      {loading && <LoadingWidget></LoadingWidget>}
    </>
  );
};

export default PurchaseOrderListScreen;
